'use client'

import { type FC } from 'react'

import {
  AD_BANNER_CART_INTERMEDIATE,
  AD_BANNER_CART_INTERMEDIATE_DIMENSIONS,
  AdServerBanner,
} from '../../ad-server'
import { useDeviceDetectorContext } from '../../device-detector'

type CartIntermediateAdBannerProps = {
  bannerClasses?: string
}
export const CartIntermediateAdBanner: FC<CartIntermediateAdBannerProps> = ({
  bannerClasses,
}) => {
  const { isMobile } = useDeviceDetectorContext()

  const bannerTags = [AD_BANNER_CART_INTERMEDIATE]

  const size = isMobile ? 'small' : 'large'
  const dimensions = AD_BANNER_CART_INTERMEDIATE_DIMENSIONS[size]

  return (
    <AdServerBanner
      bannerClasses={bannerClasses}
      bannerTags={bannerTags}
      dimensions={dimensions}
    />
  )
}
